import { z } from 'zod';

export const WorkFeedQualificationWarningModalSchema = z.object({
  agree: z.boolean().refine(value => !!value, 'Required'),
});

export type WorkFeedQualificationWarningModal = z.infer<
  typeof WorkFeedQualificationWarningModalSchema
>;
